/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Case_Chat_Import_ErrorInputs */

const en_case_chat_import_error = /** @type {(inputs: Case_Chat_Import_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Could not import the conversation: ${i?.message}`)
};

const pt_br2_case_chat_import_error = /** @type {(inputs: Case_Chat_Import_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Não foi possível importar a conversa: ${i?.message}`)
};

/**
* | output |
* | --- |
* | "Could not import the conversation: {message}" |
*
* @param {Case_Chat_Import_ErrorInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_chat_import_error = /** @type {((inputs: Case_Chat_Import_ErrorInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Chat_Import_ErrorInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_chat_import_error(inputs)
	return pt_br2_case_chat_import_error(inputs)
});